<script>
import DatePicker from './DatePicker'

export default {
  mixins: [DatePicker],
  props: {
    width: {
      type: String,
      default: '300px'
    },
    readonly: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      buttonContainerClass: 'weekly'
    }
  },
  computed: {
    minDateObject() {
      const result = new Date(this.minDate)
      result.setDate(result.getDate() - result.getDay())
      return result
    },
    maxDateObject() {
      const result = new Date(this.maxDate)
      result.setDate(result.getDate() - result.getDay() + 6)
      return result
    },
    selectedDateText() {
      const start = this.$utils.dateformat(this.selectedDate.week.startDate, this.format)
      const end = this.$utils.dateformat(this.selectedDate.week.endDate, this.format)
      return `${start} ~ ${end}`
    },
  },
  methods: {
    // override : 시작일을 리턴
    getDate() {
      return this.selectedDate.week.startDate
    },
    getData() {
      return this.selectedDate.week
    }
  }
}
</script>
